import Vue from 'vue';
import Component from 'vue-class-component';
import { ToolsComponents } from './components/tools.components';
import { Status } from '@/models/status.model';
import { APP_EVENT_BUS } from '@/core/enums/app.enum';

@Component({
  components: {
    ...ToolsComponents
  }
})
export default class Tools extends Vue {

  public status: Status = new Status();

  get organizationId() {
    let institutions: any[] = this.$store.state.ToolsStore.institutionInfo;
    return institutions.length > 0 ? institutions[0].organizationId : null;
  }

  get institutionsLoaded() {
    return this.$store.state.AppStore.institutionsLoaded;
  }

  init() {
    this.status.setLoad();
  }

  created() {
    if(!this.institutionsLoaded) {
      this.status.setLoading();
      this.$edEventBus.$on(APP_EVENT_BUS.APP_INSTITUTION_READY, this.init);
    } else {
      this.status.setLoad();
    }
  }

}